import React from "react";
import { Link } from "react-router-dom";
import Typed from "react-typed";
import HeroSection from "./Herosection";
import SocialMediaArrow from "../assets/images/arrow.png";
import {AiOutlineTwitter} from "react-icons/ai";
import {FaFacebook} from "react-icons/fa";
import {ImLinkedin} from "react-icons/im";

const Header = () => {
  return (
    <div className="header-wrapper">
      <div className="container">
        <div className="main-info">
          <HeroSection />
          <Typed
            className="typed-text"
            strings={[
              "Web Design",
              "Javascript",
              "React Js",
              "Node Js",
              "Mongo-Db",
              "Backend",
              "Python",
              "Developer...",
            ]}
            typeSpeed={30}
            backSpeed={50}
            loop
          />
          <Link to="/projects" className="btn-main-offer">
            See My Works
          </Link>
        </div>
        <div className="hero__social">
          <div className="hero__social_indicator">
            <p>Follow</p>
            <img src={SocialMediaArrow} alt="arrow" />
            <div className="hero__social__text">
              <ul>
                <li>
                  <a
                    href="https://twitter.com/ajibadde"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <AiOutlineTwitter color="#00acee"/>
                  </a>
                </li>
                <li>
                  <a
                    href="https://web.facebook.com/olunowo.olaoluwa"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaFacebook color="#3b5998"/>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/olunowo-olaoluwa-ajibade-58516519a/"
                    target="_blank"
                    rel="noreferrer"
                  >
                   <ImLinkedin color="#0e76a8"/>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
